import { InputProps, NumberInputProps } from '@chakra-ui/react';
import { useColorModeValue } from '@chakra-ui/react';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import { FormInputMeta } from '../../types/FormMetaType';

type Props = {
  meta: FormInputMeta;
  register?: any;
  hasError?: any;
} & NumberInputProps;

export default function CustomNumberInput({
  meta,
  register,
  hasError,
  ...rest
}: Props)  {
  
  const bg = useColorModeValue('white', 'gray.800')

  return (
    <>
      {register ? 
        <CC.NumberInput step={1} bg={bg} name={meta?.name} {...rest} {...register}>
            <CC.NumberInputField />
            <CC.NumberInputStepper>
                <CC.NumberIncrementStepper />
                <CC.NumberDecrementStepper />
            </CC.NumberInputStepper>
        </CC.NumberInput> : 
        <CC.NumberInput step={1} bg={bg} name={meta?.name}  onChange={meta?.onChange} {...rest}>
            <CC.NumberInputField />
            <CC.NumberInputStepper>
                <CC.NumberIncrementStepper />
                <CC.NumberDecrementStepper />
            </CC.NumberInputStepper>
        </CC.NumberInput>
       }
      {meta?.name && hasError && <CC.FormErrorMessage>{hasError.message}</CC.FormErrorMessage>}
    </>
  );
}

